// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"7223c0ee","924":"b937ff2a"}[chunkId] + ".chunk.css";
};